import { Grid, Typography } from "@mui/material";
import React from "react";
import {
  SectionContainer,
  SectionText,
  TextWrapper,
  Title,
} from "./styledFirstSection";
import { tyopgraphyStyles, titleStyle } from "./styledFirstSection";

function FirstSection() {
  return (
    <SectionContainer
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <TextWrapper
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        item
      >
        <SectionText container item justifyContent="center" alignItems="center">
          <Title container justifyContent="center" alignItems="center">
            <Typography sx={titleStyle}>Welcome To My World</Typography>
          </Title>
          <Grid item container justifyContent="center" alignItems="center">
            <Typography sx={tyopgraphyStyles}>Hi, I'm Avi Mizrahi!</Typography>
          </Grid>
          <Grid item container justifyContent="center" alignItems="center">
            <Typography sx={tyopgraphyStyles}>
              A Passionate Web Developer.
            </Typography>
          </Grid>
        </SectionText>
      </TextWrapper>
    </SectionContainer>
  );
}

export default FirstSection;
